'use client';

import React from 'react';
import styled from '@emotion/styled';
import { size, typography, colors } from "@argo/principles";
import { activeState, focusState } from "@argo/utils";
import { NAV_HEIGHT } from '../utils/constants';
const {
  primary,
  blue
} = colors;
const PrimaryNavItem = styled('div')`
  ${typography.types.XSMedium}
  color: ${primary.white};

  > a {
    color: ${primary.white};
    display: inline-block;
    padding: ${size.lg}px 20px;
    line-height: ${NAV_HEIGHT - size.lg * 2}px; 
  }

  ul {
    display: none;
  }
  
  &:hover {
    > a {
      background: ${blue.mutedBlue};
    }

    ul {
      display: flex;
      position: absolute;
      top: ${NAV_HEIGHT}px; 
    }
  }

  &:last-of-type {
    ul {
      right: 0;
    }
  }

  a:hover {
    text-decoration: none;
  }

  ${activeState}
  &::before { // to override the default active state's gray background
    background-color: transparent;
  }
  ${focusState}

`;
PrimaryNavItem.displayName = 'PrimaryNavItem';
export default React.memo(PrimaryNavItem);